export const TOOLBAR_VARIABLES = {
  //page number
  min_page: 1,

  // scale page
  scale_default: 1,
  scale_min: 0.25,
  scale_max: 5,
  max_zoom: 500,
  min_zoom: 25,
  validZoomLevels: [25, 50, 75, 100, 125, 150, 200, 250, 300, 400, 500],

  //scale image
  scale_default_image: 1,
  scale_max_image: 5,

  //rotate
  rotate_round: 360,
  rotate_radius: 90,
  rotate_min: 0,
  rotate_max: 270,

  //convert percent
  convert_percent: 100,

  //opacity
  opacity_disable: 0.4,
};

export enum ZOOM_TYPE {
  zoom_in = 'zoom-in',
  zoom_out = 'zoom-out',
}
